import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [],
  imports: [
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatRippleModule,
    MatMenuModule,
    MatTabsModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatExpansionModule,
    MatStepperModule,
    MatButtonToggleModule,
    MatListModule,
    MatSortModule,
    MatRadioModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatChipsModule,
  ],
  exports: [
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatRippleModule,
    MatMenuModule,
    MatTabsModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSelectModule,
    MatPaginatorModule,
    MatSidenavModule,
    MatExpansionModule,
    MatStepperModule,
    MatListModule,
    MatSortModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatChipsModule,
  ],
})
export class MaterialModule {}
